export default __webpack_public_path__ + "static/media/608B101E-70C2-4FAA-A4DA-B07851A7DD88_1_102_o.3ff8f8ff.jpeg";